/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITipoIdentificacion from 'Infotrack@Modelos/administracion/tipoIdentificacion/entidades/tipoIdentificacion';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITipoIdentificacion>> => [
    {
        title: formatMessage({ id: 'tipoIdentificacion.abreviatura' }),
        field: 'Abreviatura',
    },
    {
        title: formatMessage({ id: 'tipoIdentificacion.nombreTipoIdentificacion' }),
        field: 'NombreTipoIdentificacion',
    },
    {
        title: formatMessage({ id: 'tipoIdentificacion.estadoTipoIdentificacion' }),
        field: 'EstadoTipoIdentificacion',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tipoIdentificacion?: ITipoIdentificacion) => void,
    cargarTipoIdentificacion: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tipoIdentificacion: ITipoIdentificacion) => void
): Array<Action<ITipoIdentificacion>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITipoIdentificacion),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarTipoIdentificacion,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITipoIdentificacion),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<ITipoIdentificacion> = {
    maxBodyHeight: '50vh',
};
